import type { FC } from "react";

import {
  MDSButton,
  MDSButtonVariant,
  MDSText,
  MDSTextColor,
  MDSTextVariant,
  MDSTextWeight,
} from "@/mds";

import { ActionsRow, Stack } from "./shared";

interface InviteReadyAcceptedViewProps {
  message: string;
  sharedItemKindLabel: string;
  onOpen?: () => void;
}

export const InviteReadyAcceptedView: FC<InviteReadyAcceptedViewProps> = ({
  message,
  sharedItemKindLabel,
  onOpen,
}) => {
  return (
    <Stack spacing={16} style={{ alignItems: "flex-start", marginTop: "24px" }}>
      <MDSText
        as="p"
        variant={MDSTextVariant.TextSm}
        weight={MDSTextWeight.Smedium}
        color={MDSTextColor.Positive}
      >
        {message}
      </MDSText>
      {onOpen ? (
        <ActionsRow>
          <MDSButton variant={MDSButtonVariant.Contrast} onPress={onOpen}>
            Open {sharedItemKindLabel.toLowerCase()}
          </MDSButton>
        </ActionsRow>
      ) : null}
    </Stack>
  );
};
